import { ApplicationRole } from '../enums';

export const APPLICATION_ROLES = [
  ApplicationRole.AppAdmin,
  ApplicationRole.SiteAdmin,
  ApplicationRole.Contributor,
  ApplicationRole.Viewer,
];
